import React from 'react';

export interface Props {
  className?: string;
}

export const Generic16: React.FC<Props> = ({ className }) => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.03113 0.833344L5.88461 0.981137L5.19144 2.30194L4.97354 2.44907H2.5V4.46607H3.85982L3.98096 4.61259L2.5 7.44269V8.91142H2.5004H3.96874L4.11539 8.7637L4.80843 7.44282L5.02632 7.29583H7.5V5.2787H6.14018L6.01911 5.13124L7.5 2.30221V0.833344H6.03113Z"
      fill="currentColor"
    />
  </svg>
);
Generic16.displayName = 'Generic16';

export default Generic16;
